import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./components/Landing";
import ChooseLocker from "./components/ChooseLocker";
import KeyDashboard from "./components/KeyDashboard";
import LoadstringReveal from "./components/LoadstringReveal";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/get-key" element={<ChooseLocker />} />
          <Route path="/dashboard" element={<KeyDashboard />} />
          <Route path="/loadstring" element={<LoadstringReveal />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
